var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortAlpha = function SvgSortAlpha(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 1.6,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      strokeLinejoin: "round"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 6v15M22 19l-3 3M19 22l-3-3M5 12l3-7 3 7M6 10h4M5 16h6l-6 7h6"
  }))));
};
export default SvgSortAlpha;